/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {shopSearch} from '../api'

export const useMutationShopSearch = createReactQueryMutationHook('shopSearch', shopSearch)
